import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import { LINKS } from '@/constants/links';
import MoreInfoSection from '@/sections/MoreInfo';
import React from 'react';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconCoins from '@/assets/icons/heroIcons/Coins.svg';
export function MoreInfo() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t1;
  if ($[1] !== isCsLanguage || $[2] !== t) {
    t1 = <MoreInfoSection className="relative z-10 p-0!" buttons={isCsLanguage ? [{
      analyticsParam: "aboutUsMoreInfoDeferredPayment",
      icon: <IconDeferredPayment className="fillButtonIcon" />,
      testId: "aboutUsMoreInfoDeferredPayment",
      title: t("core:products.deferredPayment"),
      to: LINKS().deferredPayment
    }, {
      analyticsParam: "aboutUsMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "aboutUsMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "aboutUsMoreInfoRevolvingApplication",
      icon: <IconMaxi className="fillButtonIcon" />,
      testId: "aboutUsMoreInfoRevolvingApplication",
      title: t("core:products.revolving"),
      to: LINKS().revolving
    }, {
      analyticsParam: "aboutUsMoreInfoCard",
      icon: <IconCard className="fillButtonIcon" />,
      testId: "aboutUsMoreInfoCard",
      title: t("core:products.card"),
      to: LINKS().card
    }] : [{
      analyticsParam: "aboutUsMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "aboutUsMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "aboutUsMoreInfoWhereToShop",
      icon: <IconShoppingCart className="fillButtonIcon" />,
      testId: "aboutUsMoreInfoWhereToShop",
      title: t("core:products.whereToShop"),
      to: LINKS().whereToShop
    }, {
      analyticsParam: "aboutUsMobileApp",
      icon: <IconMobile className="fillButtonIcon" />,
      testId: "aboutUsMoreInfoMobileApp",
      title: t("core:products.mobileApp"),
      to: LINKS().mobileApp
    }, {
      analyticsParam: "aboutUsMorePricing",
      icon: <IconCoins className="fillButtonIcon" />,
      testId: "aboutUsMorePricing",
      title: t("core:products.pricing"),
      to: LINKS().pricing
    }]} />;
    $[1] = isCsLanguage;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}